<template>
    <div class="plan-settings">
        <base-loader v-if="!show || !billingPlans" key="loader" />
        <plan
            v-for="(plan, key) in billingPlans"
            v-else
            :key="key"
            :plan="plan"
            :show="show"
        />
    </div>
</template>

<script>
import Plan from '@/components/Shows/Plan/Plan';
import { mapState } from 'vuex';

export default {
    components: {
        Plan,
    },
    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },

    computed: {
        ...mapState({
            billingPlans: state => (state.billingPlans ?? []).filter((plan) => ! plan.isFree),
        }),
    },
};
</script>
